export default "__VITE_ASSET__0OIMaMj7__"